import { config } from '@fortawesome/fontawesome-svg-core';
import * as Sentry from '@sentry/gatsby';
import type { GatsbyBrowser } from 'gatsby';
import React from 'react';

import Providers from '@components/Providers/index';

import { environment, isProduction } from '@constants/env';
import { SENTRY_DSN } from '@constants/sentry';

import GlobalLayout from '@layouts/GlobalLayout/index';

Sentry.init({
  dsn: SENTRY_DSN,
  sampleRate: 1.0,
  environment,
  integrations: [
    Sentry.browserTracingIntegration(),
    ...(isProduction ? [Sentry.replayIntegration()] : []),
  ],
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: isProduction ? 0.1 : undefined,
  replaysOnErrorSampleRate: isProduction ? 1.0 : undefined,
  tracesSampleRate: ['production', 'staging'].includes(environment) ? 1.0 : 0.0,
  enabled: ['production', 'staging'].includes(environment),
});

export const onClientEntry = () => {
  /* Prevents fontawesome auto css insertion */
  config.autoAddCss = false;
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => (
  <Providers>
    {process.env.GATSBY_BUG_REPORTING_ENABLED === 'true' && (
      <>
        <script>
          {`window.markerConfig = {
            destination: '61b22cc196a8441e156d6b5c',
            source: 'snippet'
          };`}
        </script>
        <script>
          {`!function(e,r,a){if(!e.__Marker){e.__Marker={};var t=[],n={__cs:t};["show","hide","isVisible","capture","cancelCapture","unload","reload","isExtensionInstalled","setReporter","setCustomData","on","off"].forEach(function(e){n[e]=function(){var r=Array.prototype.slice.call(arguments);r.unshift(e),t.push(r)}}),e.Marker=n;var s=r.createElement("script");s.async=1,s.src="https://edge.marker.io/latest/shim.js";var i=r.getElementsByTagName("script")[0];i.parentNode.insertBefore(s,i)}}(window,document);`}
        </script>
      </>
    )}
    <GlobalLayout>{element}</GlobalLayout>
  </Providers>
);
